import { on } from "svelte/events";
import { macrotasks } from "@otto-ec/assets-core-utils/test-utils";

export function useActiveElement() {
  let activeElement = $state<HTMLElement | null>();

  const updateActiveElement = (): void => {
    let el = document.activeElement as HTMLElement | null;
    while (el?.shadowRoot) {
      el = el.shadowRoot.activeElement as HTMLElement | null;
    }
    activeElement = el;
  };

  $effect(() =>
    on(document.body, "focusin", updateActiveElement, {
      capture: true,
    }),
  );

  /*                                                             */
  /*                                                                             */
  /*                                                            */
  $effect(() => {
    if (activeElement)
      return on(activeElement, "blur", async () => {
        await macrotasks(0); /*                                                                       */
        updateActiveElement();
      });
  });

  return () => activeElement;
}
